// extracted by mini-css-extract-plugin
module.exports = {"Header":"style_Header__39M6s","Footer":"style_Footer__zzCg-"};